import { styled, TableCell } from '@mui/material';


const TableCellLeftCustom = styled(TableCell)(({ theme }) => ({
    borderLeft: '1px solid black',
    textAlign: 'center'
}));


export default TableCellLeftCustom;